export default {
  install: function(Vue) {
    // 注册所有全局组件属性组件
    register(require.context("../custom-component", true, /.vue/));
    function register(context) {
      context.keys().forEach(url => {
        const urls = url.split("/");
        const name = urls[2];
        // 如果循环到components了 也不注册
        if (!urls[3]) return;
        const type = urls[3].split(".")[0];
        const fileUrl = context(url).default;
        const componentName = name + type;
        // 只注册属性组件
        if (type !== "Attr") return;
        Vue.component(componentName, fileUrl);
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/utils/register.js